import type { IconSvgObject } from './types';

const Kaaba01Icon: IconSvgObject = [
  ["path", { d: "M3 22V5.26009C3 4.81088 3.29954 4.4168 3.73236 4.29657L11.7324 2.07435C11.9075 2.0257 12.0925 2.0257 12.2676 2.07435L20.2676 4.29657C20.7005 4.4168 21 4.81088 21 5.26009V22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 9L11.7838 7.0482C11.9267 7.01645 12.0748 7.01646 12.2177 7.0482L21.0008 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19.65 12.7L21 13M15.6 11.8L16.5 12M12.9 11.2L12 11L11.1 11.2M4.35 12.7L3 13M8.4 11.8L7.5 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 22H22", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M12 7V22", stroke: "currentColor", strokeWidth: "1.5", key: "4" }]
];

export default Kaaba01Icon;
